import React, { FC, memo, ReactNode, useState } from "react";
import { IconType } from "react-icons";
import { errorStyle } from "../../styles/globalStyles";
import DimensionsForm from "../DimensionsForm";
import { Dimensions, DimType } from "../../pages/Calculator/Calculator";

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  handleChange?: (value: string) => void;
  onDimensionsSubmit: (label: Dimensions[]) => void;
  register?: any;
  ContainerClassName?: string;
  showDimensions?: boolean;
  IconProp?: ReactNode;
  Icon?: IconType;
  error?: string;
  value?: string;
  label: string;
  maximum?: number;
  // related to Dimension modal
  toggleDimType: () => void;
  dimType: DimType;
};

const InputField: FC<Props> = ({
  handleChange,
  Icon,
  error,
  label,
  IconProp,
  ContainerClassName,
  register,
  onDimensionsSubmit,
  showDimensions = false,
  maximum = 0,
  toggleDimType,
  dimType,
  ...rest
}) => {
  const [showModal, setModal] = useState(false);
  const toggleModal = () => {
    setModal((prev) => !prev);
  };
  return (
    <div key={label} className={"overflow-hidden w-full " + ContainerClassName}>
      <label className="text-gray-400 capitalize">{label}</label>
      <div className="border rounded-md mt-1">
        <input
          {...rest}
          {...register}
          className={
            "flex-1 outline-none px-4 py-3 rounded-md w-full " + rest.className
          }
          min={0}
        />
      </div>
      {!rest.value || Number(rest.value) > maximum ? (
        <p className={errorStyle}>{error}</p>
      ) : (
        showDimensions && (
          <p
            onClick={toggleModal}
            className="hover:opacity-90 text-blue-600 cursor-pointer"
          >
            Set dimensions
          </p>
        )
      )}
      <DimensionsForm
        {...{
          dimType,
          showModal,
          toggleModal,
          toggleDimType,
          roomName: label,
          onDimensionsSubmit,
          roomCount: Number(rest.value) || 0,
        }}
      />
    </div>
  );
};

export default memo(InputField);
